export class VectiResult {
  constructor(readonly ok: boolean, readonly type: any) {
  }
}